import React, { useEffect } from 'react';
import { usePostHog } from 'posthog-js/react'
import { observer } from 'mobx-react';
import { BrowserRouter, Route, Routes, useLocation } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.min.css';
import { APP_ROUTES } from './utils/constants';
import store from './stores/';

import Welcome from './Pages/Welcome';
import Embed from './Pages/Embed';
import MainLayout from './Layouts/MainLayout';
import EmbedLayout from './Layouts/EmbedLayout';



const stores = {store}

function NavigationListener() {
  const location = useLocation();
  const posthog = usePostHog();

  useEffect(() => {
      posthog.capture('$pageview');
  }, [location, posthog]);
  return null; // This component does not render anything
}

const App = observer(() => {
    return (
      <>
      <ToastContainer />      
        <BrowserRouter>
          <NavigationListener />
          <Routes>
              <Route path={APP_ROUTES.WELCOME} exact element={<MainLayout {...stores}><Welcome {...stores} /> </MainLayout>} />
              <Route path={APP_ROUTES.EMBED} exact element={<EmbedLayout {...stores}><Embed {...stores} /> </EmbedLayout>} />
          </Routes>
        </BrowserRouter>
      </>
    );
  }
);

export default App;
